import React from 'react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { darkTheme, lightTheme } from './theme';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { theme } = useTheme();
  
  return (
    <MUIThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      {children}
    </MUIThemeProvider>
  );
};

export default ThemeProvider;
